import { useCallback } from 'react'
import { buildInvestigationBundle } from './buildInvestigationBundle'

// Builds the row-context-menu handler that asks the utility panel to
// open the research tool and start a fresh investigation on the chosen
// row. The handler is decoupled from any specific panel host -- it
// just needs `openExclusive` (Research is a 'mode: exclusive' tool
// per the registry; it overlays the chart stack rather than mounting
// inside a chart tile) and the data inputs that go into the bundle.
export function useExplainRowHandler ({
  openExclusive,
  clientId,
  config,
  activeViewName,
  asOfDate,
  orionRequest
}) {
  return useCallback((row) => {
    if (!row?.original || !orionRequest) return
    const rowPath = collectRowPath(row)
    const { bundle, subject } = buildInvestigationBundle({
      clientId,
      config,
      viewName: activeViewName || config?.name,
      asOfDate,
      row: row.original,
      rowPath,
      orionRequest
    })
    openExclusive('research', { mode: 'start', bundle, subject })
  }, [openExclusive, clientId, config, activeViewName, asOfDate, orionRequest])
}

function collectRowPath (row) {
  const path = []
  let current = row
  while (current) {
    const name = current.original?.name
    if (name) path.unshift(name)
    current = typeof current.getParentRow === 'function' ? current.getParentRow() : null
  }
  return path
}
